export default {"src":"/_next/static/media/PROK.d4d48514.svg","height":18,"width":18};